<template>
  <div class="sec-detail-base">
    <sec-description
      :has-thumbnail="true"
      :item-receive="item"
      :is-right="item.isRight"
      :is-fortune-type="isFortuneType"
    ></sec-description>
    <div class="movie-link" v-if="hasMovieLink">
      <span class="btn-movie-link" @click.stop="onToMoviesClick">動画リストはこちら</span>
    </div>
  </div>
</template>

<script>
import SecDescription from '@/utvStore/components/partials/SecDescription'
import {MENU_SEC_TYPES} from '@/CONSTS/MENUS'

export default {
  name: "SecCounselor",
  data(){
    return {
      isFortuneType: false
    }
  },
  components: {
    SecDescription
  },
  props: {
    itemsReceive: {
      type: Array,
      default() {
        return []
      }
    },
    sectionData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    item() {
      return this.itemsReceive[0]
    },
    hasMovieLink() {
      return this.item != null ? this.item.hasMovieLink : false
    }
  },
  created() {
    this.isFortuneType = this.sectionData.type === MENU_SEC_TYPES.fortune
  },
  methods: {
    onToMoviesClick(){
      location.href = `/tag/${this.item.menuId}?movies=1`
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.sec-detail-base {
  padding: 0 20px;
}
.movie-link {
  width: 100%;
  text-align: center;
  padding-top: 16px;
  .btn-movie-link {
    display: flex;
    font-weight: bold;
    font-size: 13px;
    line-height: 1;
    color: $col_temp_key1;
    border: 1px solid $col_temp_key1;
    width: 210px;
    height: 30px;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecDetailView.vue